import {createSelector} from 'reselect';
import {getCombinedData, getCombinedConfiguredItemStats, getValidConfiguredItems } from '../../utils/statsUtils';
import { makeGetSubAreaSourcesStats } from '../dsa/sourcesSelectors';
import { makeGetActiveAreas, getAllAreas, makeGetActiveSubAreas } from '../dsa/areaSelectors';
import { getDSAPeakBuffer } from '../dsaSelectors';
import { getAbilities } from '../dsa/abilitiesSelectors';

// Getters for full data sets
const getConfiguredItems = (state) => state.dsaConfig && state.dsaConfig.configuredItems || [];
const getConfiguredItemAnswers = (state) => state.dsa && state.dsa.dsaConfiguredItems || [];
const getDSAAreaIds = (state) => state.dsa && state.dsa.dsaAreas && state.dsa.dsaAreas.map(a => a.area) || [];
const getDSAAreas = (state) => state.dsa && state.dsa.dsaAreas && state.dsa.dsaAreas || [];
const getSubAreas = (state) => state.dsaConfig && state.dsaConfig.subAreas;

export const makeGetTotalSourcesStats = () => {
  return createSelector(
    [getConfiguredItems, getConfiguredItemAnswers, getDSAPeakBuffer, makeGetActiveSubAreas()],
    (questions, answers, peakBuffer, activeSubAreas) => {
      const combinedConfiguredItems = getCombinedData(questions, answers, 'configureditem');
      const activeSubAreaIds = activeSubAreas.map(sa => sa.id);
      const activeCombinedConfiguredItems = combinedConfiguredItems.filter(item => activeSubAreaIds.includes(item.subarea));
      const validConfiguredItems = getValidConfiguredItems(activeCombinedConfiguredItems);

      return getCombinedConfiguredItemStats(validConfiguredItems, peakBuffer);
    }
  );
};


export const makeGetAllAreasSourcesStats = () => {
  return createSelector(
    [getDSAAreaIds, getSubAreas, getConfiguredItems, getConfiguredItemAnswers, getDSAPeakBuffer],
    (areaIds, subAreas, questions, answers, peakBuffer) => {
      let areaStats = {};

      let combinedConfiguredItems = getCombinedData(questions, answers, 'configureditem');
      let validConfiguredItems = getValidConfiguredItems(combinedConfiguredItems);


      areaIds.forEach(areaId => {
        let areaConfiguredItems = validConfiguredItems.filter(item => {
          let subarea = subAreas.find(sa => sa.id === item.subarea);
          return subarea.area === areaId;
        });
        areaStats[areaId] = getCombinedConfiguredItemStats(areaConfiguredItems, peakBuffer);
      });

      return areaStats;
    }
  );
};

export const getSubAreasWithSourcesStats = (state, areaId) => {
  const getSubAreaSourcesStats = makeGetSubAreaSourcesStats();
  const allSubAreas = getSubAreas(state);
  const subAreas = allSubAreas.filter(a => a.area === areaId);

  return subAreas.map(subarea => {
    let stats = getSubAreaSourcesStats(state, {subarea});
    return {...subarea, stats};
  });
};


export const getActiveAreasWithSubAreasWithSourcesStats = (state) => {
  const getActiveAreas = makeGetActiveAreas();
  const activeAreas = getActiveAreas(state);
  return activeAreas.map(area => {
    const subAreas = getSubAreasWithSourcesStats(state, area.id);
    return {...area, subAreas};
  });
};

export const makeGetAllSubAreasSourcesStats = () => {
  return createSelector(
    [getAbilities, getAllAreas, getDSAAreas, getSubAreas, getConfiguredItems, getConfiguredItemAnswers, getDSAPeakBuffer],
    (abilities, allAreas, dsaAreas, subAreas, questions, answers, peakBuffer) => {
      let combinedConfiguredItems = getCombinedData(questions, answers, 'configureditem');
      let validConfiguredItems = getValidConfiguredItems(combinedConfiguredItems);

      return allAreas
        .filter(area => abilities.canActivateArea(area))
        .map(area => {
          const dsaArea = dsaAreas.find(a => a.area === area.id);
          let areaConfiguredItems = validConfiguredItems.filter(item => {
            let subarea = subAreas.find(sa => sa.id === item.subarea);
            return subarea.area === dsaArea.area;
          });

          let areaSubareas = subAreas.filter(sa => sa.area === dsaArea.area);

          let rval = {};
          rval.area = Object.assign({}, allAreas.find(a => a.id === dsaArea.area), dsaAreas.find(a => a.area === dsaArea.area));
          rval.stats = getCombinedConfiguredItemStats(areaConfiguredItems, peakBuffer);
          rval.subareas = areaSubareas.reduce((subAcc, sa) => {
            let subareaConfiguredItems = validConfiguredItems.filter(item => {
              return item.subarea === sa.id;
            });

            return subAcc.concat([{
              subarea: sa,
              stats: getCombinedConfiguredItemStats(subareaConfiguredItems, peakBuffer)
            }]);
          }, []);

          return rval;
        });
    }
  );
};




// WEBPACK FOOTER //
// ./src/selectors/analytics/overviewSelectors.js